<template>
  <div>
    <h3 class="section-title mb-2">
      {{ $t('tour_times_carshare') }}
    </h3>
    <ul class="text-btn_secondary">
      <li v-for="(data, index) in datas" v-bind:key="index" class="flex mt-1">
        <template v-if="data && data.type == 'link'">
          <div class="mt-4 w-full">
            <a :href="data.url" class="button-secondary block button-icon icon-right">
              <span>{{ data.label }}</span>
              <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
            </a>
          </div>
        </template>
        <template v-if="data && data.type == 'image'">
          <div class="mt-2 w-full">
            <img :src="data.src" class="w-full">
          </div>
        </template>
        <template v-if="data && data.type == 'text'">
          <span class="w-1/3">{{ data.caption }}：</span>
          <span class="w-2/3">{{ data.content }}</span>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    datas: function () {
      return this.place.detail.data
    }
  }
}
</script>
